import { useState, useContext } from "react";
import { BarbershopContext } from "../../providers/useProvider";
import useLogin from "../../hooks/useLogin";
import kazaslotLogo from "../../assets/logos/kazaslot.png";
import "./login.css";
const Login = () => {
  const { handleLogin, loading, error } = useLogin();
  const [formData, setFormData] = useState({
    email: "Kizo@localhost.com",
    password: "Kozmos_123456",
  });

  const config = useContext(BarbershopContext);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleLogin(formData);
  };
  const themeColor = "#000";
  return (
    <div className="d-flex justify-content-center h-100 login-page">
      <div className="d-flex align-items-center">
        <div className="login-card row g-0 shadow-lg">
          <div className="row g-0">
            <div className="col-md-6 d-flex align-items-center justify-content-center form-side">
              <div className="w-100">
                <img
                  src={kazaslotLogo}
                  alt=""
                  className="me-2 mb-5"
                  width="250"
                />

                <h3 className="text-center mt-3 mb-5">Welcome back !</h3>
                <p className="text-muted mb-4">Sign in to your account</p>
                {error && (
                  <div className="alert alert-danger py-2">{error}</div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label for="email" className="form-label small text-muted">
                      Email
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="your email address"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between">
                      <label
                        for="password"
                        className="form-label small text-muted mb-0"
                      >
                        Password
                      </label>
                    </div>
                    <input
                      id="password"
                      name="password"
                      type="password"
                      className="form-control"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="remember"
                    />
                    <label className="form-check-label small" for="remember">
                      Remember Me
                    </label>
                  </div>
                  <button type="submit" className="btn btn-dark w-100 mb-3">
                    Login
                  </button>
                </form>
              </div>
            </div>
            <div className="col-md-6 image-side d-flex align-items-center">
              <div className="slogan-panl">
                <h2 className="mb-4">
                  {" "}
                  No Papers.
                  <br /> No Missed Calls.
                  <br /> No Empty Chairs.
                </h2>
                <p>
                  Let clients book their appointments anytime with just a few
                  taps.
                  <br /> No notebooks, no constant phone calls—just a full
                  schedule and more time to focus on your craft.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
